import { inject } from "@angular/core";
import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpErrorResponse,
  HttpClient,
} from "@angular/common/http";
import { Observable, throwError, switchMap, catchError, of } from "rxjs";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { StorageService } from "../../shared/services/storage.service";
import { environment } from "../../../environments/environment";
import { REFRESH_TRIED } from "../config/interceptor-context";

export const errorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const router = inject(Router);
  const storage = inject(StorageService);
  const snackBar = inject(MatSnackBar);
  const http = inject(HttpClient);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const refreshToken = storage.getItem("refreshToken");

      const alreadyTriedRefresh = req.context.get(REFRESH_TRIED);

      if (
        error.status === 401 &&
        !alreadyTriedRefresh &&
        refreshToken &&
        !req.url.includes("api/auth/refresh")
      ) {
        return http
          .post<any>(environment.apiUrl + "/auth/refresh", { refreshToken })
          .pipe(
            switchMap((tokens) => {
              storage.setItem("accessToken", tokens.accessToken);
              storage.setItem("refreshToken", tokens.refreshToken);

              const retryReq = req.clone({
                context: req.context.set(REFRESH_TRIED, true),
                setHeaders: {
                  Authorization: `Bearer ${tokens.accessToken}`,
                },
              });

              return next(retryReq);
            }),
            catchError((refreshError) => {
              snackBar.open(
                "Sessão expirada. Faça login novamente.",
                "Fechar",
                {
                  duration: 3000,
                }
              );
              storage.removeItem("accessToken");
              storage.removeItem("refreshToken");
              router.navigate(["/login"]);
              return throwError(() => refreshError);
            })
          );
      }

      if (error.status === 401) {
        snackBar.open("Sessão expirada. Faça login novamente.", "Fechar", {
          duration: 3000,
        });
        storage.removeItem("accessToken");
        storage.removeItem("refreshToken");
        router.navigate(["/login"]);
      }

      return throwError(() => error);
    })
  );
};
